module.exports = __webpack_public_path__ + "img/hire_property.388ed4d9.jpeg";